// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__XUcq4","link-wrapper":"styles_link-wrapper__A-7PZ","footer-link":"styles_footer-link__M7slG"};